import { OrganizationsEmptyComponent } from '@app/components/core/empty';
import { clientsReportingPath, sprintReportingPath } from '@app/constants/url';
import { Roles } from '@app/utils/types';
import { UserEntity } from '@data';
import { useOrganizations } from '@data/hooks/organizations';
import { Loader } from '@ui';
import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

export interface OrganizationsInit extends React.HTMLAttributes<HTMLDivElement> {
  user: UserEntity;
}

export const OrganizationsInit = ({ user }: OrganizationsInit): ReactElement => {
  const { data: organizations, isPending } = useOrganizations(user.id);

  if (isPending) return <Loader />;

  if (organizations?.items?.length) {
    const [{ id, role }] = organizations.items;
    const redirectTo = role === Roles.client ? clientsReportingPath(id) : sprintReportingPath(id);
    return <Navigate to={redirectTo} replace />;
  }

  return <OrganizationsEmptyComponent />;
};
